/**
 * SSE streaming-calc thresholds — single source of truth.
 *
 * Consumed by:
 * - The client size-gate (Task 4): decides whether to open an SSE connection
 *   instead of a plain request, based on model size.
 * - The server-side re-check (Task 3): re-validates the client's decision and
 *   drives the heartbeat/timeout timers on the streaming route.
 *
 * These MUST come from one module. If the client and server ever compute
 * this threshold independently, they can drift — the client could decide NOT
 * to stream while the server expects a stream (or vice versa). See the
 * drift-guard test in `calc-stream-constants.test.ts`.
 */

/** Model size (vertex + edge count) above which the client streams instead of a plain request. */
export const STREAM_THRESHOLD = 3000

/** Interval, in ms, at which the server emits an SSE heartbeat to keep the connection alive. */
export const HEARTBEAT_MS = 10_000

/** Maximum time, in ms, the server allows a streamed solve to run before aborting. */
export const MAX_SOLVE_MS = 120_000
